
/*
	Performs a deep merge of a 'patches' data tree into 'base'.
	NOT merging arrays.
*/

type DeepPartial<T> = T extends object ? { [P in keyof T]?: DeepPartial<T[P]> } : T;

export function merge<T extends Record<string,unknown>>(base:T,patch:DeepPartial<T>): T
{
	const ret = {} as T;
	mergeChildren(ret,base,patch as Record<string,unknown>);
	return ret;
}

/*
									PATCH
						undef       basic       object
					+-----------+-----------+-----------+
			undef	|    N/A    | use patch | use patch |
	BASE	basic	| use base  | use patch | use patch |
			object	| use base  | use patch |  recurse  |
					+-----------+-----------+-----------+
*/

function mergeChildren(ret:Record<string,unknown>,base:Record<string,unknown>,patch:Record<string,unknown>)
{
	const keys = Object.keys({...base, ...patch});

	for (const key of keys) 
		if (typeof base[key]=='object' && typeof patch[key]=='object') {
			const child: Record<string,unknown> = {};
			ret[key] = child;
			mergeChildren(child,base[key] as Record<string,unknown>,patch[key] as Record<string,unknown>);
		}
		else if (patch[key] === undefined)
			ret[key] = base[key];
		else 
			ret[key] = patch[key];
}


